<template>
  <vx-card>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <h3>Ajouter une tâche one-shot pour un contrat</h3>
        </div>
        <!-- BOUTON DE RETOUR -->
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-button
            class="float-right"
            radius
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            @click="returnPrevRoute"
          ></vs-button>
        </div>
        <!-- /BOUTON DE RETOUR -->
      </div>
        <vx-card>
          <div class="vx-row">
            <div class="vx-col">
				<label for="" class="vs-select--label">Société</label>
            	<div class="flex">
					<vs-select
						v-model="selectedSociety"
						class="w-auto select-large"
						placeholder="Société"
						autocomplete
						:style="styleValidator('selectedSociety')"
						@change="validateOne(selectedSociety, 'selectedSociety')"
					>
						<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item, index) in displayedSocieties"
						class="w-auto"
						/>
					</vs-select>
					<vx-tooltip v-if="validators['selectedSociety'] && validators['selectedSociety'].errText !== ''" :text="errText('selectedSociety')" class="ml-3">
						<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
					</vx-tooltip>
				</div>
            </div>
            <div class="vx-col">
				<label for="" class="vs-select--label">Contrat</label>
            	<div class="flex">
					<vs-select
						autocomplete
						v-model="selectedContract"
						class="w-full select-large"
						placeholder="Contrat"
						:style="styleValidator('selectedContract')"
						@change="validateOne(selectedContract, 'selectedContract')"
					>
						<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.id + ' - ' + products_categories[item.delivery - 1]"
						v-for="(item, index) in displayedContracts"
						class="w-full"
						/>
					</vs-select>
					<vx-tooltip v-if="validators['selectedContract'] && validators['selectedContract'].errText !== ''" :text="errText('selectedContract')" class="ml-3">
						<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
					</vx-tooltip>
				</div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col">
              <vs-input
                class="inputx"
                placeholder="Lien"
                label="Lien"
                v-model="task.link"
                @change="checkLink"
                :danger="TaskValidationObjects.linkValidationObject.notValid"
                :danger-text="TaskValidationObjects.linkValidationObject.errText"/>
            </div>
          </div>
          <div class="vx-row">
			  <div class="vx-col">
				<label for="" class="vs-select--label">Description</label>
            	<div class="flex">
					<vs-input
						class="inputx"
						placeholder="Description"
						v-model="task.commentary"
						:style="styleValidator('commentary')"
						@change="validateOne(task.commentary, 'commentary')"
					/>
					<vx-tooltip v-if="validators['commentary'] && validators['commentary'].errText !== ''" :text="errText('commentary')" class="ml-3">
						<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
					</vx-tooltip>
				</div>
            </div>
          </div>
          <div class="vx-row mt-2">
            <div class="vx-col">
            <vs-button
              class="float-right"
              color="primary"
              type="filled"
              @click="formSubmitted"
              >Enregistrer Tâche
            </vs-button>
            </div>
          </div>
        </vx-card>
    </vx-card>
</template>

<script>
import Contract from "@/entities/Contract";
import Task from "@/entities/Task";
import Validator from "@/entities/Validator";
import store from "@/store/store";

import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import validatorMixin from "@/mixins/validatorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

import VxCard from "../../widgets/vx-card/VxCard.vue";

export default {
	components: {VxCard, VxTooltip},
	name: "TaskForm",
	props: {
		chartParams: Object,
		isPercent: Boolean
	},
	mixins: [dbFieldConvertor, utilsMixin, validatorMixin],
	computed: {
		societies: () => {
			return store.state.societies;
		},
		products_categories: () => {
			return store.state.products_categories.map(row => row.name);
		}
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			task: Task.getFormFields(),
			contracts: [],
			displayedContracts: [],
			displayedSocieties: [],
			selectedContract: null,
			selectedSociety: null,
			// Validator Objects
			TaskValidationObjects: {
				linkValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: false
				},
			},
			validators: {},
			check: true
		};
	},
	watch: {
		selectedSociety: function(){
			//console.log("selectedSociety watch");
			this.task.contract_society_id = this.selectedSociety;
			this.getAllContractsForSociety(this.selectedSociety);
		},
		selectedContract: function(){
			//console.log("selectedSociety watch");
			this.task.contract_id = this.selectedContract;
		},
	},
	created() {
		this.getAllSocieties();
		this.getActiveContracts();
		this.getAllProductsCategories();
	},
	methods: {
		getAllProductsCategories(){
			this.$store.dispatch("getAllProductsCategories");
		},

		/**
		 * Fetch all the societies
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},

		getAllContractsForSociety(societyId){
			this.displayedContracts = this.contracts.filter(contract => contract.society_id == societyId);
			//console.log("getAllContractsForSociety");
		},

		filterSocieties(){
			let society_list = [];
			for(let contract of this.contracts){
				if(society_list.length > 0){
					if(!society_list.find(societyId => societyId == contract.society_id)){
						society_list.push(contract.society_id);
					}
				}
				else{
					society_list.push(contract.society_id);
				}
			}

			let societiesToDisplay = [];
			for(let society of this.societies){
				if(society_list.find(societyId => society.id == societyId)){
					societiesToDisplay.push(society);
				}
			}
			this.displayedSocieties = societiesToDisplay;
			this.selectedSociety = this.displayedSocieties[0].id;
		},

		getActiveContracts(){
			Contract.getActiveContracts((err, res) => {
				if(err) //console.log(err);
				if(res) {
					this.contracts = res;
					//console.log("this.contractOptions.length", this.contracts.length);
					if(this.contracts.length > 0){
						this.filterSocieties();
					}
					else{
						this.selectedContract = null;
					}
				}
			});
			//console.log("getAllContractsForSociety");
		},
		validateOne(val, name){
			let value = val;
			value == 0 ? value = "0" : "";
			let constname = "";
			switch(name){
			case"selectedSociety":
			case"selectedContract":
				value ? value = String(val) : "";
				value == null ? value = "" : "";
				constname = "isNumberConstraint";
				break;
			case"commentary":
				value ? value = String(val) : value = "";
				constname = "nameConstraint";
				break;
			}
			this.validators[name] = new Validator({constraintName: constname});
			this.validators[name].check(value);
			this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
			this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			this.$forceUpdate();
		},
		errText(name){
			if(this.validators[name] && this.validators[name].errText !== ""){
				return this.validators[name].errText;
			}
		},
		styleValidator(name){
			if(this.validators[name] && this.validators[name].valid == false && this.validators[name].errText !== ""){
				return "border: 1px solid red !important; border-radius: 5px;";
			}
			else if(this.validators[name] && this.validators[name].errText == ""){
				return "border: 1px solid green !important; border-radius: 5px;";
			}
			else{
				return "border: none !important; border-radius: none;";
			}
		},

		formSubmitted() {
			this.check = true;
			let fields = ["selectedSociety", "selectedContract", "commentary"];
			for(let i = 0; i < fields.length; i++){
				let name = "";
				let value = this.task[fields[i]];
				fields[i] == "selectedSociety" ? value = this.selectedSociety : "";
				fields[i] == "selectedContract" ? value = this.selectedContract : "";
				value == 0 ? value = "0" : "";
				switch(fields[i]){
				case"selectedSociety":
				case"selectedContract":
					value ? value = String(value) : "";
					value == null ? value = "" : "";
					name = "isNumberConstraint";
					break;
				case"commentary":
					this.task[fields[i]] ? value = String(value) : value = "";
					name = "nameConstraint";
					break;
				}
				this.validators[fields[i]] = new Validator({constraintName: name});
				this.validators[fields[i]].check(value);
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == "" ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText !== "" ? this.check = false : "";
				this.$forceUpdate();
			}
			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				//console.log(this.task);
				//CREATION_DATE
				let today = new Date(Date.now());
				today = today.toISOString();
				today = today.substring(0, 10);
				today = today + " 02:00:00";

				//FORMATAGE LIEN
				let link = this.task.link;

				this.$http.post(this.apiUrl + "task/add", {
					commentary: this.task.commentary,
					link: link,
					status: 0,
					creation_date: today,
					finished_date: null,
					recurrence: 0,
					frequency: 0,
					archivate: 0,
					contract_id: this.task.contract_id,
					contract_society_id: this.task.contract_society_id,
					mission_id: null,
				}).then(res => {
					//console.log(res);
					this.$store.dispatch("getAllTasks");
					// Send a success notification to the user
					this.$vs.notify({title: "Succès", text: "Tâche ajoutée avec succès."});
					this.$router.go(-1);
				}).catch(err => {
					//console.log(err);
					this.$vs.notify({title: "Echec", text: "La tâche n'a pas été ajoutée."});
				});
			}
		},

		/**
		 * Checks if bccgv link is valid
		 */
		checkLink(){
			this.checkHandler(this.task.link, this.TaskValidationObjects.linkValidationObject);
		},

		/**
		 * Check if all required fields for COntract are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllRequiredFields(){
			let requiredFieldsOk = true;

			Object.entries(this.TaskValidationObjects).forEach(entry => {
				const [key, value] = entry;
				if(value.required && !value.valid && requiredFieldsOk){
					requiredFieldsOk = value.valid;
				}
			});

			return requiredFieldsOk;
		},

		/**
		 * Check if all required fields for COntract are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllFieldsError(){
			let fieldsErrorOk = true;

			Object.entries(this.TaskValidationObjects).forEach(entry => {
				const [key, value] = entry;
				if(value.notValid && fieldsErrorOk){
					fieldsErrorOk = false;
				}
			});

			return fieldsErrorOk;
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},
	}
};
</script>

<style scoped>
.role_selector_container {
  justify-content: space-between;
  width: 40%;
}

.role_container {
  justify-content: center;
}

.space_div {
  margin: 5px;
}
</style>
